import "@entaconsulting/form/dist/index.css";
import Authentication from "auth/components/authentication";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import store from "./store";

const root = createRoot(document.getElementById("root")!);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <Authentication>
      <App />
    </Authentication>
  </Provider>
  // </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
